export default __webpack_public_path__ + "static/media/login-header.6561cd5c.png";